export default "__VITE_PUBLIC_ASSET__5a004265__"